import React from "react";
import Community from "../components/Community";
const CommunityScreen = () => {
  return <Community />;
};

export default CommunityScreen;
